export enum BranchEnum {
  Branch = 'BRANCH'
}

export enum BranchEnumApi {
  branch = 'branchs/'
}
